import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { TranslationsService } from '@goatsports/shared/util';
import { RouterOutlet } from '@angular/router';

@Component({
  selector: 'goatsports-root',
  imports: [RouterOutlet],
  templateUrl: './app.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./app.component.scss'],
})
export class AppComponent implements OnInit {
  title = 'authority';

  constructor(private translationsService: TranslationsService) {}

  ngOnInit() {
    this.translationsService.initializeTranslation();
  }
}
